import {
    Assessment as AssessmentIcon,
    Cases as CasesIcon,
    CrisisAlert as CrisisAlertIcon,
    Factory as FactoryIcon,
    Storefront as StorefrontIcon,
    QuestionAnswer as QuestionAnswerIcon,
    AccountBalance as AccountBalanceIcon,
    ShoppingCart as ShoppingCartIcon,
    PeopleOutline as PeopleOutlineIcon,
    MonetizationOn as MonetizationOnIcon,
    Computer as ComputerIcon,
    PrecisionManufacturing as PrecisionManufacturingIcon,
    Inventory as InventoryIcon,
    SupportAgent as SupportAgentIcon,
    Campaign as CampaignIcon,
} from "@mui/icons-material";

export const CATEGORY_ICONS = {
    "GESTÃO": CrisisAlertIcon,
    "ADMINISTRAÇÃO": CasesIcon,
    "INDUSTRIAL": FactoryIcon,
    "COMERCIAL": StorefrontIcon,
    "MARKETING": QuestionAnswerIcon,
};

export const SUBCATEGORY_ICONS = {
    "CONTABILIDADE": AccountBalanceIcon,
    "COMPRAS": ShoppingCartIcon,
    "CONTROLADORIA": AssessmentIcon,
    "DP & DHO": PeopleOutlineIcon,
    "FINANCEIRO": MonetizationOnIcon,
    "TECNOLOGIA DA INFORMAÇÃO": ComputerIcon,
    "MANUTENÇÃO": PrecisionManufacturingIcon,
    "QUALIDADE": InventoryIcon,
    "COMERCIAL": SupportAgentIcon,
    "MARKETING": CampaignIcon,
};
